import React, { useEffect }  from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './credit/Footer';
import Market from './img/Market.png';
import LoanBoard from "./loan/LoanBoard";
import StepsSection from './StepsSection';
import SVGComponent from './img/SVGComponent'
import CreditBuilder from './credit/CreditBuilder';
import LoanRequestBoard from "./loan/LoanRequestBoard";
import MoodengCreditSection from './MoodengCreditSection';

export default function CreditRequestPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      <CreditBuilder />
      <LoanRequestBoard />
      <LoanBoard />
      <StepsSection />
      <div className="flex overflow-hidden flex-col justify-center items-center relative">
        <img
          loading="lazy"
          src={Market}
          alt="Market"
          className="object-cover w-full h-auto"
        />
      </div>
      <MoodengCreditSection />
      <SVGComponent />
      <Footer />
    </>
  );
}